// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Amount__root___kN_Ok"};